import React from 'react'

function SvgFavoris() {
  return (
    <svg
    className="menu-icon"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.17212 5.67232C3.92223 4.92244 4.93946 4.50118 6.00012 4.50118C7.06078 4.50118 8.07801 4.92244 8.82812 5.67232L10.0001 6.84332L11.1721 5.67232C11.5411 5.29028 11.9825 4.98555 12.4705 4.77592C12.9585 4.56628 13.4834 4.45594 14.0145 4.45132C14.5456 4.44671 15.0723 4.54791 15.5639 4.74904C16.0555 4.95016 16.5021 5.24717 16.8777 5.62274C17.2533 5.99832 17.5503 6.44492 17.7514 6.93651C17.9525 7.42809 18.0537 7.95481 18.0491 8.48593C18.0445 9.01705 17.9342 9.54193 17.7245 10.0299C17.5149 10.518 17.2102 10.9593 16.8281 11.3283L10.0001 18.1573L3.17212 11.3283C2.42224 10.5782 2.00098 9.56098 2.00098 8.50032C2.00098 7.43967 2.42224 6.42244 3.17212 5.67232V5.67232Z"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinejoin="round"
    />
  </svg>
  )
}

export default SvgFavoris